module.exports = __webpack_public_path__ + "static/img/geotap-game-trailer-screen.751ab28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/geotap-game/geotap-game-trailer-screen.jpg
// module id = 4IjM
// module chunks = 0